import { WindowService } from '@gen-epix/ui-core/classes/services/WindowService';

import type { EnvironmentSettings } from '../../models/environment.models';

export class EnvironmentSettingsService {
  private static __instance: EnvironmentSettingsService;
  public readonly settings: EnvironmentSettings;

  private constructor() {
    this.settings = WindowService.getInstance().window.environmentSettings;
  }

  public static getInstance(): EnvironmentSettingsService {
    if (!this.__instance) {
      this.__instance = new EnvironmentSettingsService();
    }
    return this.__instance;
  }
}
